import { render, staticRenderFns } from "./selectBlocks.vue?vue&type=template&id=230c0547"
import script from "./selectBlocks.vue?vue&type=script&lang=js"
export * from "./selectBlocks.vue?vue&type=script&lang=js"
import style0 from "./selectBlocks.vue?vue&type=style&index=0&id=230c0547&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports